import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

function extractNode(html) {
  return (new DOMParser()).parseFromString(html, 'text/html').querySelector('body').firstChild;
}

export default class extends Controller {
  static targets = ['scrollPosition']

  restoreScrollPosition() {
    if (this.hasScrollPositionTarget) {
      this.scrollPositionTarget.scrollTop = this.element.dataset.scrollTop;
    }
  }

  success(event) {
    const [, , xhr] = event.detail;
    if (xhr.response.startsWith('Turbolinks.clearCache()')) return;
    if (xhr.consumed) return;
    xhr.consumed = true;
    this.saveScrollPosition();
    const node = extractNode(xhr.response);
    this.saveScrollPositionToNode(node);
    this.element.parentNode.replaceChild(node, this.element);
    window.setTimeout(() => {
      Rails.fire(window, 'partial-load');
    }, 100);
  }

  saveScrollPosition() {
    if (!this.hasScrollPositionTarget) return;

    this.element.dataset.scrollTop = this.scrollPositionTarget.scrollTop;
  }

  saveScrollPositionToNode(node) {
    if (!this.hasScrollPositionTarget) return;

    node.dataset.scrollTop = this.scrollPositionTarget.scrollTop; // eslint-disable-line no-param-reassign
  }
}
